import React from "react";
import { NavWrap } from "../ShopForTyres";
import download from "../../assets/download.svg";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { get_warrentyDocs } from "../../actions/auth/Action";
const Warranties = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(get_warrentyDocs());
    // eslint-disable-next-line
  }, []);
  const warrenties = {
    Z1: {
      // eslint-disable-next-line
      ["RADAR NORTH AMERICA"]:
        "https://www.omni-united.com/radar-us/limited-warranty",
      // eslint-disable-next-line
      ["PATRIOT NORTH AMERICA"]:
        "https://www.omni-united.com/patriot-us/limited-warranty",
    },
    Z4: {
      // eslint-disable-next-line
      ["RADAR NORTH AMERICA"]:
        "https://www.omni-united.com/radar-us/limited-warranty",
      // eslint-disable-next-line
      ["PATRIOT NORTH AMERICA"]:
        "https://www.omni-united.com/patriot-us/limited-warranty",
    },
    Z2: {
      "Radar APAC/MEAI RADAR REST OF THE WORLD":
        "https://www.omni-united.com/limited-warranty-radar",
    },
    Z3: {
      "Radar APAC/MEAI RADAR REST OF THE WORLD":
        "https://www.omni-united.com/limited-warranty-radar",
    },
    Z5: {
      "Radar APAC/MEAI RADAR REST OF THE WORLD":
        "https://www.omni-united.com/limited-warranty-radar",
    },
    Z6: {
      "OS USA": "https://www.omni-united.com/limited-warranty-radar",
    },
  };
  return (
    <NavWrap>
      <div className="marketing">
        <h3>Warranties ({localStorage.getItem("kdgrp_txt")})</h3>
        <ul className="download-items">
          <h2>Warranty Information</h2>
        </ul>
        {localStorage.getItem("kdgrp") &&
          Object.keys(warrenties[localStorage.getItem("kdgrp")]).map((ele) => {
            return (
              <>
                <ul className="download-items">
                  <li>
                    <img src={download} alt="download" width={20} height={12} />
                    <strong>
                      <span
                        onClick={() => {
                          window.open(
                            warrenties[localStorage.getItem("kdgrp")][ele],
                            "_blank"
                          );
                        }}
                      >
                        {ele}
                      </span>
                    </strong>
                  </li>
                </ul>
                <br />
              </>
            );
          })}
      </div>
    </NavWrap>
  );
};

export default Warranties;
